import { checkElementInView } from 'propel/checkElementInView';

const mainElement = document.getElementById('main');
const animationSelectors =
	'.content-wrapper > *:not(.acf-block), .content-wrapper > .acf-block > *, .animate-in, .block-hero, .main-footer > .acf-block > *';
const sections = document.querySelectorAll(animationSelectors);
let loadCounter = 0;
let topObserver = null;
let navObserver = null;
let heroObserver = null;
let previousWidth = window.innerWidth;
const viewportEventLg = new Event('propel-viewport-changed-lg');
const viewportEventMd = new Event('propel-viewport-changed-md');
const pageScrollEvent = new Event('propel-page-scrolled');

const showSection = (e) => {
	e.classList.add('in-viewport');

	if (
		e.parentElement.classList.contains('acf-block') &&
		!e.parentElement.classList.contains('in-viewport')
	) {
		e.parentElement.classList.add('in-viewport');
	}
};

const hideSection = () => {};

const isSectionVisible = (section) => {
	const rect = section.getBoundingClientRect();

	if (
		!section.classList.contains('no-delay') &&
		rect.top < document.documentElement.clientHeight
	) {
		section.style.setProperty('--transitionDelay', `${loadCounter * 0.2}s`);

		section.classList.add('in-viewport');

		if (
			section?.parentElement?.classList.contains('acf-block') &&
			!section?.parentElement?.classList.contains('in-viewport')
		) {
			section.parentElement.classList.add('in-viewport');
		}

		if (rect.top >= 0) {
			loadCounter++;
		}
	}
};

const atTop = () => {
	document.body.classList.remove('scrolled');
};

const notAtTop = () => {
	document.body.classList.add('scrolled');

	window.dispatchEvent(pageScrollEvent);
};

const navAtTop = () => {
	document.body.classList.remove('nav-scrolled');
};

const navNotAtTop = () => {
	document.body.classList.add('nav-scrolled');
};

const navAtTop2 = () => {
	document.body.classList.remove('nav-scrolled-2');
};

const navNotAtTop2 = () => {
	document.body.classList.add('nav-scrolled-2');
};

const pastHero = () => {
	document.body.classList.add('past-hero');
};

const notPastHero = () => {
	document.body.classList.remove('past-hero');
};

const sectionsInView = () => {
	if (sections.length) {
		sections.forEach((section) => {
			isSectionVisible(section);
		});

		checkElementInView(animationSelectors, showSection, hideSection, {
			root: null,
			rootMargin: '0px 0px -5% 0px',
			threshold: [0],
		});
	}

	if (!topObserver) {
		topObserver = checkElementInView('#top', atTop, notAtTop, {
			root: null,
			rootMargin: '0px 0px 0px 0px',
			threshold: [1],
		});
	}

	if (navObserver) {
		navObserver.disconnect();
	}

	navObserver = checkElementInView('#top', navAtTop, navNotAtTop, {
		root: null,
		rootMargin: '64px 0px 0px 0px',
		threshold: [1],
	});

	navObserver = checkElementInView('#top', navAtTop2, navNotAtTop2, {
		root: null,
		rootMargin: '128px 0px 0px 0px',
		threshold: [1],
	});

	if (
		(previousWidth >= 992 && window.innerWidth < 992) ||
		(previousWidth < 992 && window.innerWidth >= 992)
	) {
		window.dispatchEvent(viewportEventLg);
	} else if (
		(previousWidth >= 768 && window.innerWidth < 768) ||
		(previousWidth < 768 && window.innerWidth >= 768)
	) {
		window.dispatchEvent(viewportEventMd);
	}

	if (mainElement?.firstElementChild) {
		if (heroObserver) {
			if (
				(previousWidth >= 992 && window.innerWidth < 992) ||
				(previousWidth < 992 && window.innerWidth >= 992)
			) {
				previousWidth = window.innerWidth;

				return;
			}

			heroObserver.disconnect();
		}

		const headerHeight =
			document.body.style.getPropertyValue('--header-height');

		const rem =
			parseFloat(getComputedStyle(document.documentElement).fontSize) ||
			16;
		const headerHeightPx = parseFloat(headerHeight) * rem + 2;

		heroObserver = checkElementInView(
			mainElement.firstElementChild,
			notPastHero,
			pastHero,
			{
				root: null,
				rootMargin: `-${headerHeightPx}px 0px 0px 0px`,
				threshold: [0],
			}
		);
	}

	previousWidth = window.innerWidth;
};

export default sectionsInView;
